/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

axios.defaults.baseURL = 'https://www.souquan.wang/'  // 设置请求地址，后面的接口都将基于这个基本请求地址

// 设置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded'

//如果在发送来自其他域的XMLHttpRequest请求之前，未设置withCredentials 为true，那么就不能为它自己的域设置cookie值。而通过设置withCredentials 为true获得的第三方cookies，将会依旧享受同源策略
//axios 默认不发送cookie，这样设置可以保存登陆成功的token和cid在cookie中
axios.defaults.withCredentials = true

//拦截器，将请求数据在发送前进行拦截，将其转化为json字符串在发送
axios.interceptors.request.use(function (config) {
    if (config.method !== 'get'&&!(config.headers["Content-Type"]=="multipart/form-data")) {
        config.data = qs.stringify(config.data)
    }
    return config
})


Vue.prototype.$ajax = {
    autoService: {
        login (url) {
            return axios({
                method: 'GET',
                url: url,
                cache: true
            })
        },
        postLogin(url,data){
          return axios({
              method: 'POST',
              url: url,
              cache: true,
              headers: { "Content-Type": "multipart/form-data" },
              data:data
          })
        },
        postData(url,data){
          return axios({
              method: 'POST',
              url: url,
              cache: true,
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data:data
          })
        }

    },


}



// WEBPACK FOOTER //
// ./src/api/api.js